/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AfterViewInit, ChangeDetectionStrategy, Component, HostListener, NgZone, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { KEY_DOWN, KEY_UP } from '@gh/core-ui';
import { denull } from '@gh/core-util';
import { first$ } from '@gh/rx/operators';
import { ICellEditorParams } from 'ag-grid-community';
import { includes } from 'lodash';
import { EditableCellOption, EditableCellModel } from '../../../state';
import { createCellFormControl } from '../../grid-cell.utils';
import { GridCellEditorComponent } from '../../grid-component.interfaces';
import { MatSelect } from '@angular/material/select';

const STOPPED_KEYS = [KEY_UP, KEY_DOWN];

@Component({
  selector: 'gh-grid-select-cell-editor',
  styles: [require('./grid-select-cell-editor.component.scss')],
  template: require('./grid-select-cell-editor.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridSelectCellEditorComponent implements GridCellEditorComponent, AfterViewInit {
  required: boolean = false;

  control: FormControl;
  options: EditableCellOption[];
  editorOptions?: any;

  @ViewChild(MatSelect, { static: false }) select: MatSelect;

  private stopEditing: () => void;

  constructor(private ngZone: NgZone) {
  }

  ngAfterViewInit(): void {
    this.ngZone.onMicrotaskEmpty.pipe(first$()).subscribe(() => {
      this.select.focus();
      this.select.open();
    });
  }

  agInit(params: ICellEditorParams): void {
    const model: EditableCellModel = params['modelFactory']({
      node: params.node,
      colDef: params.column.getColDef(),
      data: params.node.data,
    });

    this.options = params['optionSet'].getOptions({
      node: params.node,
      colDef: params.column.getColDef(),
      data: params.node.data,
    });

    this.required = model.required;
    this.control = createCellFormControl(model);
    this.stopEditing = params.stopEditing;
  }

  getValue(): any {
    return denull(this.control.value);
  }

  onClose(): void {
    this.ngZone.onMicrotaskEmpty.pipe(first$()).subscribe(() => {
      this.stopEditing();
    });
  }

  onBlur(): void {
    this.stopEditing();
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (includes(STOPPED_KEYS, event.keyCode)) {
      event.stopPropagation();
    }
  }
}
